import React, { useState, useEffect } from "react";
import { Table } from "reactstrap";
import "./index.css";
import ArrowDown from "../../../images/arrow-down.svg";
import ArrowUp from "../../../images/arrow-up.svg";
import { useMobileStatus } from "../../../new/Utils/useMobileStatus";
import circle_info from "../../../images/circle_info.svg"




export const ScoreBoard = ({ barData, onSelectedOrientationChange }) => {

  const filterData = JSON.parse(localStorage.getItem("filterData"));
  const storedOrientation = filterData.formData.orientation;

  const [selectedOrientation, setSelectedOrientation] = useState(
    storedOrientation[0]
  );

  const sendSelectedOrientationToParent = () => {
    onSelectedOrientationChange(selectedOrientation);
  };

  const isMobile = useMobileStatus();






  useEffect(() => {
    sendSelectedOrientationToParent();
  }, [selectedOrientation]);

  const groupedAttributes = barData.reduce((acc, header) => {
    header.attributes.forEach((attribute, index) => {

      if (!acc[attribute.att_name]) {
        acc[attribute.att_name] = Array(barData.length).fill("-");
      }

      if (typeof attribute.respondent_score !== "undefined") {

        acc[attribute.att_name][header.id - 1] = {
          score: attribute.respondent_score,
          greater_than_others: barData.every((otherHeader) => {
            if (otherHeader.id !== header.id) {
              const otherScoreAttribute = otherHeader.attributes.find(
                (a) => a.att_name === attribute.att_name
              );
              const otherScore = otherScoreAttribute
                ? otherScoreAttribute.respondent_score
                : undefined;
              return (
                typeof otherScore !== "undefined" &&
                attribute.respondent_score > otherScore
              );
            }
            return true;
          }),
        };
      }
    });
    return acc;
  }, {});



  const handleClick = (orientation) => {
    setSelectedOrientation(orientation);
  };

  useEffect(() => {

    const isValidOrientation = storedOrientation.includes(selectedOrientation);
    if (!isValidOrientation && storedOrientation.length > 0) {

      setSelectedOrientation(storedOrientation[0]);
    } else if (storedOrientation.length === 0) {

      setSelectedOrientation('default_or_fallback_value');
    }
  }, [storedOrientation]);

  const uniqueTableHeadings = {};

  barData.forEach(header => {
    header.attributes.forEach(attribute => {
      uniqueTableHeadings[attribute.att_name] = attribute.table_heading;
    });
  });

  const formatScoreDifference = (value) => {
    if (value === "-") return value;
    const formattedValue = value.toFixed(2);
    return formattedValue > 0 ? `+${formattedValue}` : formattedValue;
  };






  const calculateScoreDifference = (attName, scoreIndex1, scoreIndex2) => {
    const score1 =
      groupedAttributes[attName] &&
        groupedAttributes[attName][scoreIndex1] &&
        typeof groupedAttributes[attName][scoreIndex1].score === "number"
        ? groupedAttributes[attName][scoreIndex1].score
        : undefined;

    const score2 =
      groupedAttributes[attName] &&
        groupedAttributes[attName][scoreIndex2] &&
        typeof groupedAttributes[attName][scoreIndex2].score === "number"
        ? groupedAttributes[attName][scoreIndex2].score
        : undefined;

    if (typeof score1 === "number" && typeof score2 === "number") {
      return formatScoreDifference(score1 - score2);
    }
    return "-";
  };


  const getArrowIcon = (value) => {
    if (value === "-") return null;
    return (
      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        height: "100%", // Ensure the flex container fills the cell height
      }}>
        <img
          src={value > 0 ? ArrowUp : ArrowDown}
          alt={value > 0 ? "arrow-up" : "arrow-down"}
          style={{ marginLeft: "5px" }} // Adjust as needed
        />
      </div>
    );
  };









  return (
    <div
      style={{
        display: isMobile ? "block" : "flex",
        justifyContent: isMobile ? "center" : "center",
        marginTop: isMobile ? "0" : "40px",
      }}
    >
      {isMobile ? (
        <React.Fragment>
          <div style={{
            display: "flex",
            justifyContent: 'center',
            marginBottom: '20px'
          }}>
            {storedOrientation.map((orientation) => (
              <div
                key={orientation}
                onClick={() => handleClick(orientation)}
                style={{
                  border:
                    selectedOrientation === orientation
                      ? "1px solid rgba(53, 188, 57, 1)"
                      : "1px solid rgba(0, 0, 0, 0.15)",
                  height: "50px",
                  backgroundColor:
                    selectedOrientation === orientation ? "#F0FEF1" : "#FFFFFF",
                  width: "100%",
                  padding: isMobile ? '6px' : '0px',
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: 'pointer',
                  fontSize: "12px"
                }}
              >
                {orientation}
              </div>
            ))}

          </div>
          <div
            style={{

              backgroundColor: '#f0f0f0',
              padding: '4px',
              borderRadius: '4px',
              fontSize: '14px',
              marginBottom:'10px'
            }}
          >
            <img
              src={circle_info}
              alt="info icon"
              style={{ paddingRight: '2px', paddingBottom: '5px' }}

            />
            <strong>Note:</strong> Scores are out of 10.
            The minimum score is 0, and the maximum is 10.
          </div>
          <div
            style={{
              border: "1px solid rgba(0, 0, 0, 0.2)",
              width: "100%",
              borderTop: 'none',
              maxHeight: "600px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div style={{ overflowY: "auto" }}>
              <Table bordered className="custom-table">
                <thead>
                  <tr >
                    <th className="tableHeaders sticky-head">{selectedOrientation}</th>
                    {!isMobile && <th style={{ width: '22%' }} className="tableHeaders">Description</th>}

                    {barData.slice(0, 2).map((dataEntry, index) => (
                      <React.Fragment key={index}>
                        <th className="tableHeaders bardata">{dataEntry.name}</th>
                        {index === 1 && (
                          <th className="tableHeaders bardata-end bardata" style={{ textAlign: "center" }} >Gap (1 - 2)</th>
                        )}
                      </React.Fragment>
                    ))}
                    {barData.length > 2 && (
                      <React.Fragment>
                        <th className="tableHeaders bardata-start bardata">{barData[1].name}</th>
                        <th className="tableHeaders bardata">{barData[2].name}</th>
                        <th className="tableHeaders bardata bardata-end" style={{ textAlign: "center" }}>Gap (2 - 3)</th>
                        <th className="tableHeaders bardata bardata-start">{barData[0].name}</th>
                        <th className="tableHeaders bardata">{barData[2].name}</th>
                        <th style={{ textAlign: "center" }} className="tableHeaders bardata-end bardata" >Gap (1 - 3)</th>
                      </React.Fragment>
                    )}



                  </tr>
                </thead>

                <tbody style={{ maxHeight: "400px", overflowY: "auto" }}>
                  {/* <td className="tableBoardedData" colSpan={barData.length * 2 + (barData.length > 2 ? 5 : 3)}>
                <hr />
              </td> */}
                  <React.Fragment>
                    {Object.keys(groupedAttributes).map((attName, index) => (
                      <React.Fragment key={index}>
                        <tr>
                          <td className="tableBoardedData sticky-column" style={{ minWidth: "100px" }}>

                            {attName}
                          </td>
                          {!isMobile && (
                            <td className="tableBoardedData" style={{ minWidth: "250px" }}>
                              {uniqueTableHeadings[attName]}
                            </td>
                          )}

                          {groupedAttributes[attName].slice(0, 2).map((scoreObj, scoreIndex) => (
                            <React.Fragment key={`${index}-${scoreIndex}`}>
                              <td
                                className="tableBoardedData"
                                style={{ minWidth: "120px" }}
                              >
                                {typeof scoreObj.score === "number"
                                  ? scoreObj.score
                                  : scoreObj.score}
                              </td>
                            </React.Fragment>
                          ))}
                          {barData.length > 1 && (
                            <td className="tableBoardedData" style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", minWidth: "100px" }}>
                              <span style={{ marginRight: "5px" }}>{calculateScoreDifference(attName, 0, 1)}</span>
                              {getArrowIcon(calculateScoreDifference(attName, 0, 1))}
                            </td>
                          )}
                          {barData.length > 2 && (
                            <React.Fragment>
                              <td
                                className="tableBoardedData"
                                style={{ minWidth: "120px" }}
                              >
                                {typeof groupedAttributes[attName][1].score === "number"
                                  ? groupedAttributes[attName][1].score
                                  : groupedAttributes[attName][1].score}
                              </td>
                              <td
                                className="tableBoardedData"
                                style={{ minWidth: "120px" }}
                              >
                                {typeof groupedAttributes[attName][2].score === "number"
                                  ? groupedAttributes[attName][2].score
                                  : groupedAttributes[attName][2].score}
                              </td>
                              <td className="tableBoardedData" style={{ textAlign: "center", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", minWidth: "100px" }}>
                                <span style={{ marginRight: "5px" }}>{calculateScoreDifference(attName, 1, 2)}</span>

                                {getArrowIcon(calculateScoreDifference(attName, 1, 2))}
                              </td>
                              <td
                                className="tableBoardedData"
                                style={{ minWidth: "120px" }}
                              >
                                {typeof groupedAttributes[attName][0].score === "number"
                                  ? groupedAttributes[attName][0].score
                                  : groupedAttributes[attName][0].score}
                              </td>
                              <td
                                className="tableBoardedData"
                                style={{ minWidth: "120px" }}
                              >
                                {typeof groupedAttributes[attName][2].score === "number"
                                  ? groupedAttributes[attName][2].score
                                  : groupedAttributes[attName][2].score}
                              </td>
                              <td className="tableBoardedData" style={{ textAlign: "center", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", minWidth: "100px" }}>
                                <span style={{ marginRight: "5px" }}>{calculateScoreDifference(attName, 0, 2)}</span>
                                {getArrowIcon(calculateScoreDifference(attName, 0, 2))}
                              </td>
                            </React.Fragment>
                          )}
                        </tr>
                        {/* <tr>
                      <td className="tableBoardedData" colSpan={barData.length * 2 + (barData.length > 2 ? 5 : 3)}>
                        <hr />
                      </td>
                    </tr> */}
                      </React.Fragment>
                    ))}
                  </React.Fragment>
                </tbody>
              </Table>
            </div>
          </div>
        </React.Fragment>
      ) : (
        <div
          className="tableHead"
        >
          <div style={{ marginBottom: "20px" }}>
            <div style={{
              display: "flex",
              justifyContent: 'flex-start',
            }}>
              {storedOrientation.map((orientation) => (
                <div
                  key={orientation}
                  onClick={() => handleClick(orientation)}
                  style={{
                    border:
                      selectedOrientation === orientation
                        ? "1px solid rgba(53, 188, 57, 1)"
                        : "1px solid rgba(0, 0, 0, 0.15)",
                    height: "50px",
                    backgroundColor:
                      selectedOrientation === orientation ? "#F0FEF1" : "#FFFFFF",
                    width: "150px",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: 'pointer',
                    fontSize: '16px'
                  }}
                >
                  {orientation}
                </div>
              ))}
              <div
                style={{
                  marginLeft: '20px',
                  backgroundColor: '#f0f0f0',
                  padding: '6px',
                  borderRadius: '4px',
                  fontSize: '14px'
                }}
              >
                <img
                  src={circle_info}
                  alt="info icon"
                  style={{ paddingRight: '2px', paddingBottom: '5px' }}

                />
                <strong>Note:</strong> Scores are out of 10. <br></br>
                The minimum score is 0, and the maximum is 10.
              </div>


            </div>
          </div>
          <div style={{ overflowY: "auto" }}>
            <Table bordered className="custom-table">
              <thead>
                <tr >
                  <th className="tableHeaders sticky-head">{selectedOrientation}</th>
                  {!isMobile && <th style={{ width: '22%' }} className="tableHeaders">Description</th>}

                  {barData.slice(0, 2).map((dataEntry, index) => (
                    <React.Fragment key={index}>
                      <th className="tableHeaders bardata">{dataEntry.name}</th>
                      {index === 1 && (
                        <th className="tableHeaders bardata-end bardata" style={{ textAlign: "center" }} >Gap (1 - 2)</th>
                      )}
                    </React.Fragment>
                  ))}
                  {barData.length > 2 && (
                    <React.Fragment>
                      <th className="tableHeaders bardata-start bardata">{barData[1].name}</th>
                      <th className="tableHeaders bardata">{barData[2].name}</th>
                      <th className="tableHeaders bardata bardata-end" style={{ textAlign: "center" }}>Gap (2 - 3)</th>
                      <th className="tableHeaders bardata bardata-start">{barData[0].name}</th>
                      <th className="tableHeaders bardata">{barData[2].name}</th>
                      <th style={{ textAlign: "center" }} className="tableHeaders bardata-end bardata" >Gap (1 - 3)</th>
                    </React.Fragment>
                  )}
                </tr>
              </thead>

              <tbody style={{ maxHeight: "400px", overflowY: "auto" }}>
                {/* <td className="tableBoardedData" colSpan={barData.length * 2 + (barData.length > 2 ? 5 : 3)}>
                <hr />
              </td> */}
                <React.Fragment>
                  {Object.keys(groupedAttributes).map((attName, index) => (
                    <React.Fragment key={index}>
                      <tr>
                        <td className="tableBoardedData sticky-column" style={{ minWidth: "100px" }}>

                          {attName}
                        </td>
                        {!isMobile && (
                          <td className="tableBoardedData" style={{ minWidth: "250px" }}>
                            {uniqueTableHeadings[attName]}
                          </td>
                        )}

                        {groupedAttributes[attName].slice(0, 2).map((scoreObj, scoreIndex) => (
                          <React.Fragment key={`${index}-${scoreIndex}`}>
                            <td
                              className="tableBoardedData"
                              style={{ minWidth: "120px" }}
                            >
                              {typeof scoreObj.score === "number"
                                ? scoreObj.score
                                : scoreObj.score}
                            </td>
                          </React.Fragment>
                        ))}
                        {barData.length > 1 && (
                          <td className="tableBoardedData" style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", minWidth: "100px" }}>
                            <span style={{ marginRight: "5px" }}>{calculateScoreDifference(attName, 0, 1)}</span>
                            {getArrowIcon(calculateScoreDifference(attName, 0, 1))}
                          </td>
                        )}
                        {barData.length > 2 && (
                          <React.Fragment>
                            <td
                              className="tableBoardedData"
                              style={{ minWidth: "120px" }}
                            >
                              {typeof groupedAttributes[attName][1].score === "number"
                                ? groupedAttributes[attName][1].score
                                : groupedAttributes[attName][1].score}
                            </td>
                            <td
                              className="tableBoardedData"
                              style={{ minWidth: "120px" }}
                            >
                              {typeof groupedAttributes[attName][2].score === "number"
                                ? groupedAttributes[attName][2].score
                                : groupedAttributes[attName][2].score}
                            </td>
                            <td className="tableBoardedData" style={{ textAlign: "center", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", minWidth: "100px" }}>
                              <span style={{ marginRight: "5px" }}>{calculateScoreDifference(attName, 1, 2)}</span>

                              {getArrowIcon(calculateScoreDifference(attName, 1, 2))}
                            </td>
                            <td
                              className="tableBoardedData"
                              style={{ minWidth: "120px" }}
                            >
                              {typeof groupedAttributes[attName][0].score === "number"
                                ? groupedAttributes[attName][0].score
                                : groupedAttributes[attName][0].score}
                            </td>
                            <td
                              className="tableBoardedData"
                              style={{ minWidth: "120px" }}
                            >
                              {typeof groupedAttributes[attName][2].score === "number"
                                ? groupedAttributes[attName][2].score
                                : groupedAttributes[attName][2].score}
                            </td>
                            <td className="tableBoardedData" style={{ textAlign: "center", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", minWidth: "100px" }}>
                              <span style={{ marginRight: "5px" }}>{calculateScoreDifference(attName, 0, 2)}</span>
                              {getArrowIcon(calculateScoreDifference(attName, 0, 2))}
                            </td>
                          </React.Fragment>
                        )}
                      </tr>
                      {/* <tr>
                      <td className="tableBoardedData" colSpan={barData.length * 2 + (barData.length > 2 ? 5 : 3)}>
                        <hr />
                      </td>
                    </tr> */}
                    </React.Fragment>
                  ))}
                </React.Fragment>
              </tbody>
            </Table>
          </div>
        </div>
      )}
    </div>
  );


};



// WEBPACK FOOTER //
// ./src/_components/common/ScoreBoard/index.jsx